import { SidebarInset, SidebarProvider } from "@/components/ui/Sidebar";
import { Outlet } from "react-router";
import { AppSidebar } from "./components/dashboard/AppSidebar";
import { SiteHeader } from "./components/dashboard/SiteHeader";

function App() {
  return (
    <div className="[--header-height:calc(theme(spacing.14))]">
      <SidebarProvider className="flex flex-col">
        <SiteHeader />
        <div className="flex flex-1">
          <AppSidebar />
          <SidebarInset>
            <div className="p-4 py-8">
              <Outlet />
            </div>
          </SidebarInset>
        </div>
      </SidebarProvider>
    </div>
  );
}

export default App;
